import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent {
  isGreen = false;

  @Input() activeStep: number = 0;

  actualStep = [
    'Verificación',
    'Planes',
    'Datos personales',
    'Resumen'
  ]

  nextStep = [
    'Planes',
    'Datos personales',
    'Resumen',
    'Resumen'
  ]

  constructor() { }

  ngOnInit(): void {
    
  }
}
